import React from "react";
import styles from "./reports.module.scss";
import adminStyle from "../admin/admin.module.scss";
import { IReport } from "./StudentReportList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";

interface ReportDetailsProp {
  report: IReport;
  onBack: (value: any) => void;
  onAction: (value: any) => void;
}

const StudentReportDetails = ({
  report,
  onBack,
  onAction,
}: ReportDetailsProp) => {
  return (
    <div>
      <div className={styles.header}>
        <FontAwesomeIcon
          style={{ cursor: "pointer" }}
          onClick={onBack}
          icon={faArrowLeftLong}
          className={adminStyle.backIcon}
        />
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Report Summary</h2>
        <div className={styles.detailRow}>
          <span>
            <strong>Reported By:</strong> {report.studentName}
          </span>
          <span>
            <strong>Teacher:</strong> {report.teacherName}
          </span>
        </div>
        <div className={styles.detailRow}>
          <span>
            <strong>Date:</strong> {report.date}
          </span>
          <span>
            <strong>Email:</strong> {report.email}
          </span>
        </div>
        <div className={styles.detailRow}>
          <span>
            <strong>Status:</strong> {report.status}
          </span>
          <span>
            <strong>Category:</strong> {report.category}
          </span>
        </div>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Report Message</h2>
        <div className={styles.messageBox}>{report.message}</div>
      </div>

      {/* <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Admin Notes</h2>
        <textarea
          style={{ width: "100%", height: "5rem" }}
          placeholder="Add internal notes or actions taken..."
        />
      </div> */}

      <div className={styles.actions}>
        <button
          className={styles.reviewed}
          onClick={() => onAction("reviewed")}
        >
          Mark as Reviewed
        </button>

        <button className={styles.dismiss} onClick={() => onAction("dismiss")}>
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default StudentReportDetails;
